import { render, staticRenderFns } from "./OrderNoteEditor.vue?vue&type=template&id=142950a9&scoped=true&"
import script from "./OrderNoteEditor.vue?vue&type=script&lang=js&"
export * from "./OrderNoteEditor.vue?vue&type=script&lang=js&"
import style0 from "./OrderNoteEditor.vue?vue&type=style&index=0&id=142950a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../order-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142950a9",
  null
  
)

export default component.exports